// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.18.4
//   protoc               v7.36.2
// source: cbinsights/cbientityservice/cbientityservice.proto

/* eslint-disable */

export const protobufPackage = "cbientityservice";

export const protobufFileName = "cbinsights/cbientityservice/cbientityservice.proto";

/** version 21.9.0 */

export enum OldPrivateEntityType {
  UNKNOWN_PRIVATE_ENTITY_TYPE = "UNKNOWN_PRIVATE_ENTITY_TYPE",
  PRIVATE_COMPANY = "PRIVATE_COMPANY",
  PRIVATE_INVESTOR = "PRIVATE_INVESTOR",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum CompetitorSource {
  UNKNOWN_COMPETITOR_SOURCE = "UNKNOWN_COMPETITOR_SOURCE",
  SOURCE_ANALYST_BRIEFING = "SOURCE_ANALYST_BRIEFING",
  SOURCE_MARKET_MAP = "SOURCE_MARKET_MAP",
  SOURCE_ADMIN = "SOURCE_ADMIN",
  SOURCE_MODEL_GENERATED = "SOURCE_MODEL_GENERATED",
  SOURCE_PRESUMED_ADMIN = "SOURCE_PRESUMED_ADMIN",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum IdType {
  UNKNOWN = "UNKNOWN",
  COMPANY = "COMPANY",
  INVESTOR = "INVESTOR",
  CBI_ENTITY = "CBI_ENTITY",
  TEAM_ENTITY = "TEAM_ENTITY",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum IdAliasType {
  UNKNOWN_ALIAS_TYPE = "UNKNOWN_ALIAS_TYPE",
  DBA = "DBA",
  FKA = "FKA",
  LEGAL_NAME = "LEGAL_NAME",
  NATIVE_LANGUAGE_NAME = "NATIVE_LANGUAGE_NAME",
  PRODUCT = "PRODUCT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum CbiEntityType {
  UNKNOWN_CBI_ENTITY_TYPE = "UNKNOWN_CBI_ENTITY_TYPE",
  COMPANY_ENTITY_TYPE = "COMPANY_ENTITY_TYPE",
  INVESTOR_ENTITY_TYPE = "INVESTOR_ENTITY_TYPE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum SortOrder {
  SortOrder_NONE = "SortOrder_NONE",
  SortOrder_DESCENDING = "SortOrder_DESCENDING",
  SortOrder_ASCENDING = "SortOrder_ASCENDING",
  UNRECOGNIZED = "UNRECOGNIZED",
}

/** The enum should match the ids in the database */
export enum SourceType {
  UNKNOWN_SOURCE_TYPE = "UNKNOWN_SOURCE_TYPE",
  INVESTOR_PROFILE = "INVESTOR_PROFILE",
  BUSINESS_RELATIONSHIP = "BUSINESS_RELATIONSHIP",
  TOP_SEARCH = "TOP_SEARCH",
  DATA_REQUEST = "DATA_REQUEST",
  CLIENT_REQUEST = "CLIENT_REQUEST",
  REVENUE = "REVENUE",
  SERVICE_PROVIDER = "SERVICE_PROVIDER",
  BR_PLAYER_ID = "BR_PLAYER_ID",
  QUALTRICS_JOB = "QUALTRICS_JOB",
  GEO_COVERAGE = "GEO_COVERAGE",
  PERSON_ADMIN = "PERSON_ADMIN",
  CHROME_EXTENSION = "CHROME_EXTENSION",
  TOP_SEARCH_CBI_EMPLOYEE = "TOP_SEARCH_CBI_EMPLOYEE",
  API_ORG_SEARCH = "API_ORG_SEARCH",
  COLLECTIONS_URL_UPLOADS = "COLLECTIONS_URL_UPLOADS",
  COLLECTIONS_URL_CBI_EMPLOYEE = "COLLECTIONS_URL_CBI_EMPLOYEE",
  TECH_RELATED = "TECH_RELATED",
  NEWS_QUEUE = "NEWS_QUEUE",
  CUSTOMER_REQUEST = "CUSTOMER_REQUEST",
  OTHER = "OTHER",
  DESCRIPTION_GENERATION_SERVICE = "DESCRIPTION_GENERATION_SERVICE",
  DESCRIPTION_GENERATION_SERVICE_LOW_PRIORITY = "DESCRIPTION_GENERATION_SERVICE_LOW_PRIORITY",
  BUSINESS_MODEL_TAGS = "BUSINESS_MODEL_TAGS",
  CORESIGNAL_COMPANY = "CORESIGNAL_COMPANY",
  INVESTOR_PROFILE_CHROME_EXTESNION = "INVESTOR_PROFILE_CHROME_EXTESNION",
  COMPANY_PROFILE_CHROME_EXTENSION = "COMPANY_PROFILE_CHROME_EXTENSION",
  BRIGHTDATA_ENTITY = "BRIGHTDATA_ENTITY",
  EXTERNAL_PROFILE_EDITOR_ENTITY = "EXTERNAL_PROFILE_EDITOR_ENTITY",
  UNRECOGNIZED = "UNRECOGNIZED",
}

/** The enum should match the ids in the database */
export enum DraftStatus {
  UNKNOWN_STATUS = "UNKNOWN_STATUS",
  READY_FOR_ENRICHMENT = "READY_FOR_ENRICHMENT",
  READY_FOR_QA = "READY_FOR_QA",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum FundingSourceType {
  UNKNOWN_FUNDING_SOURCE = "UNKNOWN_FUNDING_SOURCE",
  VC_SURVEY = "VC_SURVEY",
  FUNDINGS_BY_NEWS_QUEUE = "FUNDINGS_BY_NEWS_QUEUE",
  INVESTOR_PORTFOLIO_SCRAPER = "INVESTOR_PORTFOLIO_SCRAPER",
  CORESIGNAL = "CORESIGNAL",
  INVESTOR_EDITOR = "INVESTOR_EDITOR",
  COMPANY_EDITOR = "COMPANY_EDITOR",
  DJVS = "DJVS",
  COMPANY_SURVEY = "COMPANY_SURVEY",
  INVESTOR_LIST = "INVESTOR_LIST",
  BRIGHTDATA = "BRIGHTDATA",
  EXTERNAL_PROFILE_EDITOR = "EXTERNAL_PROFILE_EDITOR",
  UNRECOGNIZED = "UNRECOGNIZED",
}

/**
 * Whether the person is currently in stealth, derived from their current work experiences.
 * UNSPECIFIED also covers "not in stealth".
 */
export enum StealthStatus {
  STEALTH_STATUS_UNSPECIFIED = "STEALTH_STATUS_UNSPECIFIED",
  STEALTH_STATUS_IN_STEALTH = "STEALTH_STATUS_IN_STEALTH",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum Department {
  DEPARTMENT_UNSPECIFIED = "DEPARTMENT_UNSPECIFIED",
  DEPARTMENT_ADMINISTRATIVE = "DEPARTMENT_ADMINISTRATIVE",
  DEPARTMENT_BOARD = "DEPARTMENT_BOARD",
  DEPARTMENT_C_SUITE = "DEPARTMENT_C_SUITE",
  DEPARTMENT_CONSULTING = "DEPARTMENT_CONSULTING",
  DEPARTMENT_CUSTOMER_SERVICE = "DEPARTMENT_CUSTOMER_SERVICE",
  DEPARTMENT_DESIGN = "DEPARTMENT_DESIGN",
  DEPARTMENT_EDUCATION = "DEPARTMENT_EDUCATION",
  DEPARTMENT_ENGINEERING_AND_TECHNICAL = "DEPARTMENT_ENGINEERING_AND_TECHNICAL",
  DEPARTMENT_FINANCE_AND_ACCOUNTING = "DEPARTMENT_FINANCE_AND_ACCOUNTING",
  DEPARTMENT_GENERAL_MANAGEMENT = "DEPARTMENT_GENERAL_MANAGEMENT",
  DEPARTMENT_HUMAN_RESOURCES = "DEPARTMENT_HUMAN_RESOURCES",
  DEPARTMENT_LEGAL = "DEPARTMENT_LEGAL",
  DEPARTMENT_MARKETING = "DEPARTMENT_MARKETING",
  DEPARTMENT_MEDICAL = "DEPARTMENT_MEDICAL",
  DEPARTMENT_OPERATIONS = "DEPARTMENT_OPERATIONS",
  DEPARTMENT_OTHER = "DEPARTMENT_OTHER",
  DEPARTMENT_PRODUCT = "DEPARTMENT_PRODUCT",
  DEPARTMENT_PROJECT_MANAGEMENT = "DEPARTMENT_PROJECT_MANAGEMENT",
  DEPARTMENT_REAL_ESTATE = "DEPARTMENT_REAL_ESTATE",
  DEPARTMENT_RESEARCH = "DEPARTMENT_RESEARCH",
  DEPARTMENT_SALES = "DEPARTMENT_SALES",
  DEPARTMENT_TRADES = "DEPARTMENT_TRADES",
  UNRECOGNIZED = "UNRECOGNIZED",
}

/** Display departments is a remapping of Department for display purposes */
export enum DisplayDepartment {
  DISPLAY_DEPARTMENT_UNSPECIFIED = "DISPLAY_DEPARTMENT_UNSPECIFIED",
  DISPLAY_DEPARTMENT_ADMINISTRATIVE = "DISPLAY_DEPARTMENT_ADMINISTRATIVE",
  DISPLAY_DEPARTMENT_CONSULTING = "DISPLAY_DEPARTMENT_CONSULTING",
  DISPLAY_DEPARTMENT_CUSTOMER_SERVICE = "DISPLAY_DEPARTMENT_CUSTOMER_SERVICE",
  DISPLAY_DEPARTMENT_FINANCE = "DISPLAY_DEPARTMENT_FINANCE",
  DISPLAY_DEPARTMENT_LEGAL = "DISPLAY_DEPARTMENT_LEGAL",
  DISPLAY_DEPARTMENT_MARKETING = "DISPLAY_DEPARTMENT_MARKETING",
  DISPLAY_DEPARTMENT_OPERATIONS = "DISPLAY_DEPARTMENT_OPERATIONS",
  DISPLAY_DEPARTMENT_PRODUCT = "DISPLAY_DEPARTMENT_PRODUCT",
  DISPLAY_DEPARTMENT_PROJECT_MANAGEMENT = "DISPLAY_DEPARTMENT_PROJECT_MANAGEMENT",
  DISPLAY_DEPARTMENT_RESEARCH = "DISPLAY_DEPARTMENT_RESEARCH",
  DISPLAY_DEPARTMENT_SALES = "DISPLAY_DEPARTMENT_SALES",
  DISPLAY_DEPARTMENT_TECHNOLOGY = "DISPLAY_DEPARTMENT_TECHNOLOGY",
  DISPLAY_DEPARTMENT_OTHER = "DISPLAY_DEPARTMENT_OTHER",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum ManagementLevel {
  MANAGEMENT_LEVEL_UNSPECIFIED = "MANAGEMENT_LEVEL_UNSPECIFIED",
  MANAGEMENT_LEVEL_JUNIOR = "MANAGEMENT_LEVEL_JUNIOR",
  MANAGEMENT_LEVEL_MIDLEVEL = "MANAGEMENT_LEVEL_MIDLEVEL",
  MANAGEMENT_LEVEL_SENIOR = "MANAGEMENT_LEVEL_SENIOR",
  MANAGEMENT_LEVEL_MANAGER = "MANAGEMENT_LEVEL_MANAGER",
  MANAGEMENT_LEVEL_DIRECTOR = "MANAGEMENT_LEVEL_DIRECTOR",
  MANAGEMENT_LEVEL_VP = "MANAGEMENT_LEVEL_VP",
  MANAGEMENT_LEVEL_C_LEVEL = "MANAGEMENT_LEVEL_C_LEVEL",
  MANAGEMENT_LEVEL_BOARD = "MANAGEMENT_LEVEL_BOARD",
  MANAGEMENT_LEVEL_OWNER = "MANAGEMENT_LEVEL_OWNER",
  MANAGEMENT_LEVEL_FOUNDER = "MANAGEMENT_LEVEL_FOUNDER",
  MANAGEMENT_LEVEL_UNKNOWN = "MANAGEMENT_LEVEL_UNKNOWN",
  MANAGEMENT_LEVEL_PRESIDENT = "MANAGEMENT_LEVEL_PRESIDENT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

/** Display management level is a remapping of ManagementLevel for display purposes */
export enum DisplayManagementLevel {
  DISPLAY_MANAGEMENT_LEVEL_UNSPECIFIED = "DISPLAY_MANAGEMENT_LEVEL_UNSPECIFIED",
  DISPLAY_MANAGEMENT_LEVEL_BOARD = "DISPLAY_MANAGEMENT_LEVEL_BOARD",
  DISPLAY_MANAGEMENT_LEVEL_C_LEVEL = "DISPLAY_MANAGEMENT_LEVEL_C_LEVEL",
  DISPLAY_MANAGEMENT_LEVEL_DIRECTOR = "DISPLAY_MANAGEMENT_LEVEL_DIRECTOR",
  DISPLAY_MANAGEMENT_LEVEL_FOUNDER = "DISPLAY_MANAGEMENT_LEVEL_FOUNDER",
  DISPLAY_MANAGEMENT_LEVEL_MANAGER = "DISPLAY_MANAGEMENT_LEVEL_MANAGER",
  DISPLAY_MANAGEMENT_LEVEL_OTHER = "DISPLAY_MANAGEMENT_LEVEL_OTHER",
  DISPLAY_MANAGEMENT_LEVEL_VP = "DISPLAY_MANAGEMENT_LEVEL_VP",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum DisplayDegree {
  DISPLAY_DEGREE_UNSPECIFIED = "DISPLAY_DEGREE_UNSPECIFIED",
  DISPLAY_DEGREE_ASSOCIATES = "DISPLAY_DEGREE_ASSOCIATES",
  DISPLAY_DEGREE_BACHELORS = "DISPLAY_DEGREE_BACHELORS",
  DISPLAY_DEGREE_MASTERS = "DISPLAY_DEGREE_MASTERS",
  DISPLAY_DEGREE_PHD = "DISPLAY_DEGREE_PHD",
  DISPLAY_DEGREE_OTHER = "DISPLAY_DEGREE_OTHER",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum RevenueGrowthType {
  REVENUE_GROWTH_TYPE_UNSPECIFIED = "REVENUE_GROWTH_TYPE_UNSPECIFIED",
  YOY = "YOY",
  CAGR = "CAGR",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum GroupBy {
  /** GROUP_UNSPECIFIED - Will default to the group by RELATIONSHIP */
  GROUP_UNSPECIFIED = "GROUP_UNSPECIFIED",
  /** RELATIONSHIP - return the service relationship record for each relationship */
  RELATIONSHIP = "RELATIONSHIP",
  /** ENTITY - Return the service relationships for each entity */
  ENTITY = "ENTITY",
  UNRECOGNIZED = "UNRECOGNIZED",
}

/**
 * Mirrors cbitagservice.TagSource. Used to attribute newly-created tag-entity
 * assignments to a caller identity when writing tags via cbi-tag-service.
 */
export enum TagSource {
  SOURCE_UNSPECIFIED = "SOURCE_UNSPECIFIED",
  ADMIN = "ADMIN",
  INTERNAL = "INTERNAL",
  MODEL = "MODEL",
  USER = "USER",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface Empty {
}

export interface SuccessStatus {
  success: boolean;
  errorMessage: string;
}

export interface TeamEntity {
  idTeamEntity: number;
  idTeam: number;
  idCreator: number;
  entityName: string;
  description?: string | undefined;
  url?: string | undefined;
  oldPrivateEntityId: number;
  oldPrivateEntityType: OldPrivateEntityType;
}

export interface TeamEntities {
  teamEntities: TeamEntity[];
}

export interface TeamEntitySearch {
  searchTerm: string;
  idTeam: number;
  limit?: number | undefined;
}

export interface SearchTerm {
  searchTerm: string;
  limit: number;
}

export interface GetEntityUrlUniquenessRequest {
  searchTerm: string;
  limit: number;
  checkPrimaryUrl: boolean;
  urls: string[];
  checkEntityDraft: boolean;
}

export interface SearchInfo {
  searchTerm: string;
  limit: number;
  entityType: IdType;
  searchVcFunds: boolean;
  serviceProvidersOnly: boolean;
  searchDrafts: boolean;
}

export interface EntitySearchResults {
  entitySearchResults: EntitySearchResult[];
}

export interface EntitySearchResult {
  idCbiEntity: number;
  name: string;
  url: string;
  description: string;
  altUrl: string;
  alias: string;
  entityType: IdType;
  idInvestor: number;
  idCompany: number;
  vcFund: string;
  idInvestorCategory: number;
  aliasType: IdAliasType;
  serviceProvider: ServiceProvider | undefined;
  idEntityDraft: string;
  foundInDraft: boolean;
  isDraftInvestor: boolean;
  draftStatus: DraftStatus;
  isMappedEntity: boolean;
  isManualPeopleUpdatePermitted: boolean;
}

export interface CbiEntityUrl {
  url: string;
}

export interface ScrapedDescription {
  entityDescription: { [key: string]: string };
}

export interface ScrapedDescription_EntityDescriptionEntry {
  key: string;
  value: string;
}

export interface IdCbiEntity {
  idCbiEntity: number;
  errorMessage: string;
}

export interface RepeatedIdCbiEntity {
  idCbiEntities: number[];
}

export interface GetEntityFundingsRequest {
  idCbiEntity: number;
  errorMessage: string;
  includeInactive: boolean;
}

export interface GetEntitiesFundingsRequest {
  idCbiEntities: number[];
  /** if true valuation data should match what is in profiles.  If false it will only return what was entered in the admin */
  augmentValuationData: boolean;
  includeEntityInfo: boolean;
  idEntityDrafts: string[];
  includeFundingDrafts: boolean;
  includeInactive: boolean;
}

export interface GetEntitiesInvestmentsRequest {
  idCbiEntities: number[];
  /** if true valuation data should match what is in profiles.  If false it will only return what was entered in the admin */
  augmentValuationData: boolean;
  limit: number;
  offset: number;
  /** accepted sort columns: fundedCompanyName */
  sortColumn: string;
  sortOrder: SortOrder;
  includeNewsMention: boolean;
  includeInactive: boolean;
}

export interface Ids {
  ids: number[];
}

export interface InfoRequest {
  id: number;
  idType: IdType;
}

export interface GeneralCbiEntityInfo {
  entityNameInfo: EntityNameInfo | undefined;
  description: string;
  urlInfo: UrlInfo | undefined;
  email: string;
  status: EntityStatusInfo | undefined;
  ciks: number[];
  foundedYear: number;
  taxonomy: Taxonomy | undefined;
  addresses: Address[];
  idCbiEntity: number;
  idCompany: number;
  idInvestor: number;
  idParentEntities: number[];
  idChildEntities: number[];
  parentEntities: SimpleCbiEntityInfo[];
  childEntities: SimpleCbiEntityInfo[];
  totalFunding: number;
  vcBacked: boolean;
  idPrimaryCbiEntityType: CbiEntityType;
  isCompany: boolean;
  isInvestor: boolean;
  companySlug: string;
  investorSlug: string;
  idRootParentEntities: number[];
  rootParentEntities: SimpleCbiEntityInfo[];
  /**
   * DEPRECATED for writes: Do not update tagGroups through cbi-entity-service.
   * Use cbi-tag-service directly to manage tag group assignments.
   * This field is read-only in this context — it is populated when fetching entity info.
   */
  tagGroups: TagGroup[];
  sourceData: SourceData[];
  isTier2Entity: boolean;
  linkedinUrl: string;
  naicsTaxonomy: NAICSTaxonomy | undefined;
  stealthEntryDate: string;
  stealthEmergenceDate: string;
}

export interface SimpleCbiEntityInfo {
  idCbiEntity: number;
  idCompany: number;
  idInvestor: number;
  entityNameInfo: EntityNameInfo | undefined;
  idTeamEntity: number;
  primaryUrl: string;
  idPrimaryCbiEntityType: IdType;
  idEntityDraft: string;
  isTier2Entity: boolean;
}

export interface RepeatedInfoRequest {
  entities: InfoRequest[];
  includeTier2Entity: boolean;
}

export interface GeneralCbiEntitiesInfo {
  entities: GeneralCbiEntityInfo[];
}

export interface SimpleCbiEntitiesInfo {
  entities: SimpleCbiEntityInfo[];
}

export interface SourceData {
  sourceType: SourceType;
  idSource: number;
}

export interface EntityInfo {
  entityNameInfo: EntityNameInfo | undefined;
  description: string;
  urlInfo: UrlInfo | undefined;
  email: string;
  status: EntityStatusInfo | undefined;
  ciks: number[];
  foundedYear: number;
  taxonomy: Taxonomy | undefined;
  addresses: Address[];
  idCbiEntity: number;
  createCompany: boolean;
  createInvestor: boolean;
  idPrimaryCbiEntityType: CbiEntityType;
  createEntityShell: boolean;
  idEntityDraft: string;
  idParentEntities: number[];
  idChildEntities: number[];
  parentEntities: SimpleCbiEntityInfo[];
  childEntities: SimpleCbiEntityInfo[];
  isCompany: boolean;
  isInvestor: boolean;
  idCompany: number;
  idInvestor: number;
  idRootParentEntities: number[];
  rootParentEntities: SimpleCbiEntityInfo[];
  /**
   * DEPRECATED for writes: Do not update tagGroups through cbi-entity-service.
   * Use cbi-tag-service directly to manage tag group assignments.
   * This field is read-only in this context — it is populated when fetching entity info.
   */
  tagGroups: TagGroup[];
  isTier2Entity: boolean;
  linkedinUrl: string;
  stealthEntryDate: string;
  stealthEmergenceDate: string;
}

export interface EntityNameInfo {
  primaryName: string;
  companyName: string;
  investorName: string;
  aliases: Alias[];
}

export interface Alias {
  idAlias: number;
  alias: string;
  aliasType: number;
  entityType: number;
  active: boolean;
}

export interface UrlInfo {
  primaryUrl: string;
  additionalUrls: AlternateUrls[];
}

export interface AlternateUrls {
  idUrl: number;
  url: string;
  entityType: IdType;
  active: boolean;
}

export interface EntityStatusInfo {
  idStatus: number;
  status: string;
}

export interface AllEntityStatusValues {
  allEntityStatusValues: EntityStatusInfo[];
}

export interface GetEntitiesMosaicScoresRequest {
  entities: InfoRequest[];
  deltaTimeSpanDays: number;
}

export interface MosaicScoresResponse {
  entityScores: MosaicScore[];
}

export interface MosaicScore {
  idCbiEntity: number;
  idCompany: number;
  overall: number;
  momentum: number;
  market: number;
  money: number;
  deltaOverall: number;
  deltaMomentum: number;
  deltaMarket: number;
  deltaMoney: number;
  management: number;
  deltaManagement: number;
}

export interface Taxonomy {
  sector: SectorValue | undefined;
  industry: IndustryValue | undefined;
  subIndustry: SubIndustryValue | undefined;
  category: CompanyCategoryValue | undefined;
  investorCategory: InvestorCategoryValue | undefined;
}

export interface SectorValue {
  idSector: number;
  name: string;
  description: string;
}

export interface IndustryValue {
  idIndustry: number;
  idSector: number;
  name: string;
  description: string;
}

export interface SubIndustryValue {
  idSubIndustry: number;
  idIndustry: number;
  name: string;
  description: string;
}

export interface CompanyCategoryValue {
  idCompanyCategory: number;
  name: string;
}

export interface InvestorCategoryValue {
  idInvestorCategory: number;
  name: string;
  idType: number;
}

export interface NAICSTaxonomy {
  sector: NAICSSector | undefined;
  subsector: NAICSSubsector | undefined;
  industryGroup: NAICSIndustryGroup | undefined;
  industry: NAICSIndustry | undefined;
  nationalIndustry: NAICSNationalIndustry | undefined;
  mostGranularCode: string;
  version: string;
}

export interface NAICSSector {
  sectorCode: string;
  title: string;
}

export interface NAICSSubsector {
  subsectorCode: string;
  title: string;
}

export interface NAICSIndustryGroup {
  industryGroupCode: string;
  title: string;
}

export interface NAICSIndustry {
  industryCode: string;
  title: string;
}

export interface NAICSNationalIndustry {
  nationalIndustryCode: string;
  title: string;
}

/** Note: Taken directly from the company service! */
export interface Address {
  idAddress: number;
  addressName: string;
  hqFlag: number;
  street1: string;
  street2: string;
  cityInfo: CityInfo | undefined;
  stateInfo: StateInfo | undefined;
  zip: string;
  countryInfo: CountryInfo | undefined;
  idContinent: number;
  phone: string;
  fax: string;
  idGeoRegionNew: number;
  idType: IdType;
  continentName: string;
  latitude: string;
  longitude: string;
  regions: MsaRegion[];
}

export interface MsaRegion {
  idRegion: number;
  region: string;
}

export interface AllCityValues {
  cityInfo: CityInfo[];
}

export interface AllStateValues {
  stateInfo: StateInfo[];
}

export interface AllCountryValues {
  countryInfo: CountryInfo[];
}

export interface AllContinentValues {
  continentInfo: ContinentInfo[];
}

export interface AllRegionValues {
  regionInfo: RegionInfo[];
}

export interface IdCountry {
  idCountry: number;
}

export interface IdSector {
  idSector: number;
}

export interface IdIndustry {
  idIndustry: number;
}

export interface AllSectorValues {
  taxonomyMap: TaxonomyMap[];
}

export interface TaxonomyMap {
  id: number;
  name: string;
  children: TaxonomyMap[];
  description: string;
}

export interface AllIndustryValues {
  allIndustryValues: IndustryValue[];
}

export interface AllSubIndustryValues {
  allSubIndustryValues: SubIndustryValue[];
}

export interface AllCompanyCategoryValues {
  allCompanyCategoryValues: CompanyCategoryValue[];
}

export interface AllInvestorCategoryValues {
  allInvestorCategoryValues: InvestorCategoryValue[];
}

export interface CityInfo {
  name: string;
  idCity: number;
  idState: number;
  idCountry: number;
  zip: string;
  matchRank: number;
  population: number;
}

export interface SearchForCityInfo {
  name: string;
  idCity: number;
  idState: number;
  idCountry: number;
  limit: number;
  fuzzySearch: boolean;
}

export interface StateInfo {
  idState: number;
  idCountry: number;
  name: string;
  stateAbbr: string;
}

export interface CountryInfo {
  idCountry: number;
  name: string;
  idContinent: number;
}

export interface ContinentInfo {
  idContinent: number;
  name: string;
}

export interface RegionInfo {
  idRegion: number;
  name: string;
}

export interface Name {
  name: string;
}

export interface RoundInfo {
  idRound: number;
  name: string;
  idStatus: number;
  simplifiedRound: string;
  searchMapping: string;
  exitIndicator: boolean;
  fundingIndicator: boolean;
  activeIndicator: boolean;
}

export interface AllRoundValues {
  roundInfo: RoundInfo[];
}

export interface PersonTitle {
  idPersonTitle: number;
  title: string;
  titleCode: string;
  titleRank: number;
  isKeyRole: boolean;
}

export interface AllPersonTitles {
  personTitleMaps: { [key: number]: AllPersonTitles_PersonTitles };
}

export interface AllPersonTitles_PersonTitles {
  personTitles: PersonTitle[];
}

export interface AllPersonTitles_PersonTitleMapsEntry {
  key: number;
  value: AllPersonTitles_PersonTitles | undefined;
}

export interface AllAliasTypeValues {
  aliasTypeValues: AliasType[];
}

export interface AliasType {
  idAliasType: number;
  aliasType: string;
  description: string;
}

export interface EmploymentRelationships {
  employmentRelationships: EmploymentRelationship[];
}

export interface EmploymentRelationship {
  idInvPerson: number;
  idCbiEntity: number;
}

export interface IdInvestorPeople {
  idInvestorPeople: number[];
}

export interface InvestorPeople {
  investorPerson: InvestorPerson[];
}

/**
 * A person associated with an investor.
 *
 * Used on funding rounds as a board member. On that path firms, startDate and
 * endDate are not populated, so firms is always [] and the dates always empty.
 * Other RPCs returning this message do populate them.
 */
export interface InvestorPerson {
  /** Unique investor person record identifier. */
  idInvestorPerson: number;
  /** First name. */
  fname: string;
  /** Middle name. */
  mname: string;
  /** Last name. */
  lname: string;
  /**
   * Biographical summary, passed through from the database unprocessed, so it
   * may contain HTML markup and entities such as &amp;.
   */
  bio: string;
  /** Current job title. */
  title: string;
  /** Email address. */
  email: string;
  /** Investor identifier associated with this person. 0 when there is none. */
  idInvestor: number;
  /** Full display name, fname and lname joined by a space. Excludes mname. */
  name: string;
  /** Primary investor firm name. */
  investor: string;
  /** Investor firm associations. Always empty on funding rounds. */
  firms: FirmDetails[];
  /**
   * Twitter handle. Unlike facebook and linkedin this is typically a handle
   * rather than a full profile URL.
   */
  twitter: string;
  /** Facebook profile URL. */
  facebook: string;
  /** LinkedIn profile URL. */
  linkedin: string;
  /**
   * Start date of the primary investor association. Always empty on funding
   * rounds.
   */
  startDate: string;
  /**
   * End date of the primary investor association, empty if current. Always
   * empty on funding rounds.
   */
  endDate: string;
}

export interface AllFundingInfo {
  idCbiEntity: number;
  idEntityDraft: string;
  fundingInfo: FundingInfo[];
  fundingDraftInfo: FundingInfo[];
  shouldUpdateCompanyStatus: boolean;
  entityName: string;
  description: string;
  status: EntityStatusInfo | undefined;
  url: string;
}

export interface RepeatedAllFundingInfo {
  fundingInfos: AllFundingInfo[];
}

export interface RepeatedAllInvestmentInfo {
  investmentInfos: AllFundingInfo[];
  numRecords: number;
}

/**
 * A single funding round for a single company.
 *
 * Published on entity.funding.full-state, one message per round, keyed by
 * fundingRound.idFunding.
 */
export interface FundingInfo {
  /** CBI entity identifier for the funded company. */
  idCbiEntity: number;
  /**
   * Date of the funding round, as "MM/DD/YYYY HH:MM:SS". A day rather than an
   * exact time, so the time is always 00:00:00. Empty when unknown.
   */
  fundingDate: string;
  /** Round type metadata. Absent from the JSON when unset, rather than {}. */
  fundingRound:
    | FundingRound
    | undefined;
  /**
   * Capital raised in this round, in USD millions, to 2 decimal places.
   * 0 means either zero or unknown; the two are not distinguishable.
   */
  amount: number;
  /** Minimum reported valuation at the time of this round, in USD millions. */
  minValuation: number;
  /** Maximum reported valuation at the time of this round, in USD millions. */
  maxValuation: number;
  /** Investors who participated in this round, lead investors first. */
  investors: Investor[];
  /** News articles and other sources evidencing this round. */
  mentions: MentionsInfo[];
  /**
   * Board members associated with this round. Their firms, startDate and
   * endDate are not populated here.
   */
  boardOfDirectors: InvestorPerson[];
  /** Post-money valuation at the time of this round, in USD millions. */
  valuation: number;
  /** IPO valuation, in USD millions. Exit rounds only; 0 otherwise. */
  ipo: number;
  /**
   * Unix timestamp of the funding date, in seconds. The only 64-bit integer
   * here, so the only field emitted as a quoted string.
   */
  fundingUnixTs: number;
  /** True if this round is a fundraising event rather than an exit. */
  fundingIndicator: boolean;
  /** Round name mapped for search display. */
  searchMapping: string;
  /** Simplified round category used for grouping, e.g. "Early Stage VC". */
  roundMapping: string;
  /** True if this round is an exit event such as an acquisition or IPO. */
  exitIndicator: boolean;
  /** Display name of the company that received the funding. */
  fundedCompanyName: string;
  /** Website URL of the company that received the funding. */
  fundedCompanyUrl: string;
  /** True if this is an equity financing round. */
  equityIndicator: boolean;
  /**
   * AI-generated summary of the round. A JSON string inside this JSON document,
   * so it needs parsing a second time. Empty when there is no summary.
   */
  summaryJson: string;
  /**
   * Investors making their first recorded investment in this company as of this
   * round. With investorDisplayFollowOn this splits investors by whether the
   * investor had already invested in this company before this round. Investors
   * on rounds with no funding date appear in neither list.
   */
  investorDisplayNew: InvestorDisplay[];
  /**
   * Investors who had already invested in this company before this round.
   * See investorDisplayNew.
   */
  investorDisplayFollowOn: InvestorDisplay[];
  /**
   * Parent entity this entity was divested from. Divestiture rounds only;
   * absent from the JSON otherwise.
   */
  divestitureFrom:
    | DivestitureFrom
    | undefined;
  /** Data pipelines that sourced this round, as enum value names. */
  sources: FundingSourceType[];
  /** True if this round has not yet been verified by a CBI analyst. */
  unverified: boolean;
}

export interface GetAllRoundValuesRequest {
  equityOnly: boolean;
  includeInactive: boolean;
}

export interface AllFundingRounds {
  idCbiEntity: number;
  fundingRound: FundingRound[];
}

export interface GetAllEntityFundingRoundsRequest {
  idCbiEntity: number;
  includeUnassociatedRounds: boolean;
  equityOnly: boolean;
  includeInactive: boolean;
}

export interface AllEntityFundingRounds {
  idCbiEntity: number;
  entityFundingRounds: FundingRound[];
  unassociatedFundingRounds: RoundInfo[];
}

/**
 * A minimal investor reference, used for the new/follow-on display lists on a
 * funding round.
 */
export interface InvestorDisplay {
  /** Investor-specific identifier. */
  idInvestor: number;
  /** Investor display name. */
  name: string;
  /** CBI entity identifier for this investor. 0 when there is no linked entity. */
  idCbiEntity: number;
}

/** An investor's participation in a funding round. */
export interface Investor {
  /** CBI entity identifier for this investor. 0 when there is no linked entity. */
  idCbiEntity: number;
  /** Investor-specific identifier. Distinct from idCbiEntity. */
  idInvestor: number;
  /** Investor display name. */
  name: string;
  /** True if this investor led the round. */
  leadInvestor: boolean;
  /** Investor type classification identifier. 0 when unclassified. */
  investorTypeId: number;
  /**
   * Investor type label, e.g. "Venture Capital", "Corporation", "Bank". Comes
   * from an editable reference table, so treat it as a closed set that can gain
   * members rather than a fixed enum. Empty when the investor has no type.
   */
  investorType: string;
  /**
   * Draft entity UUID, set only when this investor is in draft state. Always
   * empty on published funding rounds.
   */
  idEntityDraft: string;
}

/** The parent entity a divestiture round separated this entity from. */
export interface DivestitureFrom {
  /**
   * CBI entity identifier of the parent that divested this entity. May be a
   * company or an investor. 0 when not a divestiture round.
   */
  idCbiEntity: number;
  /** Display name of the parent entity. Empty when not a divestiture round. */
  parentEntityName: string;
}

/** Round type metadata for a funding round. */
export interface FundingRound {
  /**
   * Unique funding record identifier. Also the Kafka message key on
   * entity.funding.full-state.
   */
  idFunding: number;
  /** Round type identifier, referencing the rounds reference table. */
  idRound: number;
  /** Round type display name, e.g. "Series A", "Angel", "IPO". */
  name: string;
  /** True if this funding round record is active, i.e. not soft-deleted. */
  isActive: boolean;
}

/**
 * A news article or other source that evidences a funding round.
 *
 * Only idFunding, url and idFundingSource come from the CBI database. The rest
 * are resolved from the news service by url, and are zero values when that
 * lookup finds nothing.
 */
export interface MentionsInfo {
  /** Funding record this mention is associated with. */
  idFunding: number;
  /**
   * URL of the news article or source. Also the key used to resolve the
   * remaining fields.
   */
  url: string;
  /** Identifier of the mention row itself. */
  idFundingSource: number;
  /** Identifier of the publication in the news service. 0 when unresolved. */
  idSource: number;
  /** Title of the article or source document. */
  title: string;
  /** Publication or source outlet name. */
  sourceName: string;
  /**
   * Publication date of the article, as "YYYY-MM-DD HH:MM:SS". Note this is a
   * different format from FundingInfo.fundingDate.
   */
  date: string;
  /** Language identifier of the article. 0 when unknown. */
  idLanguage: number;
}

export interface IdFunding {
  idFunding: number;
}

export interface IdFundings {
  idFundings: number[];
  errorMessage: string;
  fundingMeta: FundingRound[];
}

export interface ProcessFundingRequest {
  idCbiEntity: number;
  fundingInfo: FundingInfo[];
  shouldUpdateCompanyStatus: boolean;
  itemsToDelete: FundingIdsToDelete | undefined;
  overrideValidation: boolean;
}

export interface ProcessFundingResponse {
  idCbiEntity: number;
  fundingInfo: FundingInfo[];
  errorMessage: string;
}

export interface FundingIdsToDelete {
  idFunding: number[];
  fundingInvestors: FundingInvestor[];
  fundingMentions: FundingMentions[];
  fundingBoardOfDirectors: FundingBoDPeople[];
  shouldUpdateCompanyStatus: boolean;
}

export interface FundingInvestor {
  idInvestor: number;
  idFunding: number;
}

export interface FundingMentions {
  idFundingSource: number;
  idFunding: number;
}

export interface FundingBoDPeople {
  idBoardOfDirector: number;
  idFunding: number;
}

export interface AllCompetitors {
  competitor: CompetitorInfo[];
}

export interface CompetitorInfo {
  idCompanyCompetitor: number;
  idCbiEntity: number;
  name: string;
  url: string;
  level: number;
  twoWay: boolean;
  idCbiEntityCompetitor: number;
  description: string;
  relevancyScore: number;
  rank: number;
  idCompetitorSources: CompetitorSource[];
  selfSourced: boolean;
}

export interface AllFirmographics {
  firmographics: FirmographicsInfo[];
}

export interface FirmographicsInfo {
  idCbiEntity: number;
  legalNames: string[];
  competitors: FirmographicsCompetitor[];
  tsCompany: string;
  naicsTaxonomy: NAICSTaxonomy | undefined;
  idCompanyNaicsMapping: number;
}

export interface FirmographicsCompetitor {
  idCbiEntityCompetitor: number;
  name: string;
  relevancyScore: number;
}

export interface UpdateCompetitorsRequest {
  competitors: UpdateCompetitorRequest[];
}

export interface UpdateCompetitorRequest {
  idCbiEntity: number;
  idCbiEntityCompetitor: number;
  twoWay: boolean;
  source: string;
  selfSourced: boolean;
  relevancyScore: number;
  idSource: CompetitorSource;
  secondRelevancyScore: number;
}

export interface AllVcFundInfo {
  idCbiEntity: number;
  vcFundInfo: VcFundInfo[];
}

export interface IdVcFunds {
  idVcFunds: number[];
}

export interface VcFundInfo {
  idVcFund: number;
  fundName: string;
  sources: VcFundSource[];
  ciks: number[];
  amountRaised: number;
  amountTarget: number;
  startDate: string;
  closeDate: string;
  limitedPartners: LimitedPartner[];
  idCbiEntity: number;
  vintageYear: number;
  idVcFundType: number;
  idVcFundStatus: number;
  focuses: VcFundFocus[];
}

export interface LimitedPartner {
  idLimitedPartner: number;
  limitedPartner: string;
  idCbiEntity: number;
  commitment: number;
  idCommitmentType: number;
}

export interface VcFundSource {
  idVcFundSource: number;
  url: string;
}

export interface VcFundFocus {
  idVcFundFocusType: number;
  value: number;
  idVcFundFocus: number;
}

export interface AllLimitedPartnerInfo {
  limitedPartners: LimitedPartner[];
}

export interface VcFundCik {
  idVcFund: number;
  cik: number;
}

export interface VcFundLimitedPartner {
  idVcFund: number;
  idLimitedPartner: number;
}

export interface VcFundIdsToDelete {
  idVcFunds: number[];
  idVcFundSources: number[];
  vcFundCiks: VcFundCik[];
  vcFundLimitedPartners: VcFundLimitedPartner[];
  idVcFundFocuses: number[];
}

export interface AllCbiEntityEmployees {
  idCbiEntity: number;
  cbiEntityEmployeeInfo: CbiEntityEmployeeInfo[];
}

export interface CbiEntityEmployeeInfo {
  idPerson: number;
  email: string;
  fname: string;
  mname: string;
  lname: string;
  title: string;
  bio: string;
  linkedin: string;
  facebook: string;
  twitter: string;
  startDate: string;
  endDate: string;
  current: boolean;
}

export interface IdEmployees {
  idEmployee: number[];
}

export interface AllSalesMetrics {
  idCbiEntity: number;
  salesMetricInfo: SalesMetricInfo[];
}

export interface SalesMetricInfo {
  idMetric: number;
  maxSales: number;
  minSales: number;
  sources: SalesMetricSource[];
  date: string;
}

export interface IdSalesMetrics {
  idMetric: number[];
}

export interface SalesMetricSource {
  idSource: number;
  url: string;
}

export interface Slug {
  slug: string;
}

export interface PublicPage {
  publicPage: string;
}

export interface Success {
  success: boolean;
}

export interface UniquenessResponse {
  idCbiEntity: number;
  name: string;
  urlEntityMaps: { [key: string]: UniquenessResponse_ListEntities };
  idEntityDraft: string;
}

export interface UniquenessResponse_ListEntities {
  cbiEntities: SimpleCbiEntityInfo[];
}

export interface UniquenessResponse_UrlEntityMapsEntry {
  key: string;
  value: UniquenessResponse_ListEntities | undefined;
}

export interface IdAddresses {
  idCbiEntity: number;
  idAddresses: number[];
}

export interface TeamEntityUpdateInfo {
  idTeamEntity: number;
  entityName?: string | undefined;
  description?: string | undefined;
  url?: string | undefined;
}

export interface TeamEntitiesUpdateInfo {
  teamEntities: TeamEntityUpdateInfo[];
}

export interface IdTeamEntities {
  idTeamEntities: number[];
}

export interface Ciks {
  ciks: Cik[];
  checkDrafts: boolean;
}

export interface Cik {
  idCompany: number;
  cik: number;
}

export interface SalesMetricIdsToDelete {
  idMetrics: number[];
  idSources: IdSalesMetricSource[];
}

export interface IdSalesMetricSource {
  idMetric: number;
  idSource: number;
}

export interface ProcessSalesMetricRequest {
  idCbiEntity: number;
  salesMetricInfo: SalesMetricInfo[];
  itemsToDelete: SalesMetricIdsToDelete | undefined;
}

export interface EntityIds {
  idCbiEntity: number;
  idCompany: number;
  idInvestor: number;
  idPrimaryEntityType: CbiEntityType;
}

export interface ParentChildRelationships {
  parentChildRelationships: ParentChildEntities[];
}

export interface ParentChildEntities {
  parent: InfoRequest | undefined;
  child: InfoRequest | undefined;
}

export interface GetCompanyAndInvestorIdsRequest {
  entityNameAndUrls: EntityNameAndUrl[];
  getInactive: boolean;
  allowNoUrl?: boolean | undefined;
}

export interface EntityNameAndUrl {
  name: string;
  url: string;
}

export interface GetCompanyAndInvestorIdsResponse {
  entityIds: EntityIds[];
  entitiesNotMatch: EntityNameAndUrl[];
}

export interface GetEntitiesInvestorExitsRequest {
  idCbiEntities: number[];
  startDate: string;
  endDate: string;
  aggregateOnly: boolean;
  /** if true valuation data should match what is in profiles.  If false it will only return what was entered in the admin */
  augmentValuationData: boolean;
  /** if true then return non empty MentionsInfo in response. */
  includeNewsMention: boolean;
}

export interface GetEntitiesInvestorExitsResponse {
  entityExits: EntityExitInfo[];
}

export interface GetEntitiesDivestituresRequest {
  idCbiEntities: number[];
  idInvestors: number[];
  includeNewsMention: boolean;
}

export interface GetEntitiesDivestituresResponse {
  entityDivestitures: EntityExitInfo[];
}

export interface EntityExitInfo {
  idCbiEntity: number;
  numExits: number;
  exits: ExitInfo[];
  mentions: MentionsInfo[];
}

export interface ExitInfo {
  companyIdCbiEntity: number;
  companyIdCompany: number;
  companyName: string;
  acquirerIdCbiEntity: number;
  acquirerIdInvestor: number;
  acquirerName: string;
  acquirerUrl: string;
  amount: number;
  idRound: number;
  round: string;
  roundMapping: string;
  tsFunding: string;
  valuation: number;
  minValuation: number;
  maxValuation: number;
  searchMapping: string;
  idFunding: number;
}

export interface CreateAcquisitionRequest {
  idInvestor: number;
  idCompany: number;
}

export interface CreateAcquisitionResponse {
  idInvestor: number;
  idCompany: number;
}

export interface DeleteAcquisitionRequest {
  idCompany: number;
  idInvestor: number;
}

export interface GetEntitiesAcquirersRequest {
  idCbiEntities: number[];
}

export interface GetEntitiesAcquirersResponse {
  acquirers: Acquirer[];
}

export interface Acquirer {
  id: number;
  name: string;
  idAcquiree: number;
}

export interface InvestorPeopleDetailsResponse {
  investorPeopleDetails: InvestorPersonDetails[];
}

export interface InvestorPersonDetails {
  idInvPerson: number;
  firmDetails: FirmDetails[];
  boardDetails: BoardDetails[];
  roundDetails: RoundDetails[];
}

/**
 * One person-to-investor-firm association, held in InvestorPerson.firms.
 * Not populated on funding rounds.
 */
export interface FirmDetails {
  /** Investor firm display name. */
  firm: string;
  /** Investor person identifier this association belongs to. */
  idInvPerson: number;
  /** Start date at this firm. */
  startDate: string;
  /** Title held at this firm. */
  title: string;
  /** CBI entity identifier for this firm. 0 when there is no linked entity. */
  idCbiEntity: number;
  /** Investor identifier for this firm. */
  idInvestor: number;
  /** End date at this firm, empty if the association is current. */
  endDate: string;
  /** True if this is an active association with the firm. */
  current: boolean;
  /** Standardized person title identifier. 0 when the title is unmapped. */
  idPersonTitle: number;
}

export interface BoardDetails {
  company: string;
  current: boolean;
  startDate: string;
  endDate: string;
  idInvPerson: number;
  idCbiEntityInvestment: number;
  title: string;
  url: string;
  idPersonTitle: number;
}

export interface RoundDetails {
  idCbiEntityInvestment: number;
  investorRounds: InvestorRound[];
  allRounds: FundingRound[];
}

export interface InvestorRound {
  idFunding: number;
  idInvPerson: number;
  idCbiEntityInvestment: number;
  round: string;
}

export interface BoardMemberFundingRoundRequest {
  boardMemberFundingRounds: BoardMemberFundingRound[];
}

export interface BoardMemberFundingRound {
  idInvPerson: number;
  idFunding: number;
}

export interface AddFirmsToInvestorPeopleRequest {
  firms: FirmDetails[];
}

export interface RemoveFirmsFromInvestorPeopleRequest {
  firmsToDelete: FirmDetails[];
}

export interface MapIdResponse {
  companyMap: { [key: number]: number };
  investorMap: { [key: number]: number };
}

export interface MapIdResponse_CompanyMapEntry {
  key: number;
  value: number;
}

export interface MapIdResponse_InvestorMapEntry {
  key: number;
  value: number;
}

export interface XigniteOrg {
  symbol: string;
  exchange: string;
  idFactSetIssuer: string;
  idCbiEntity: number;
}

export interface GetIdCbiEntitiesForXigniteOrgsRequest {
  xigniteOrgs: XigniteOrg[];
}

export interface GetIdCbiEntitiesForXigniteOrgsResponse {
  xigniteOrgs: XigniteOrg[];
}

export interface GetEntityIdsMappingRequest {
  idType: IdType;
  ids: number[];
  includeInactive: boolean;
}

export interface GetEntityIdsMappingResponse {
  entityIds: EntityIds[];
}

export interface GetSimpleCbiEntitiesInfoBySlugRequest {
  slugs: string[];
  pageSize: number;
  pageToken: string;
}

export interface GetSimpleCbiEntitiesInfoBySlugResponse {
  entities: SimpleCbiEntityInfo[];
  nextPageToken: string;
}

export interface CalculateNumPageViewsRequest {
  idCbiEntities: number[];
}

export interface CalculateNumPageViewsResponse {
  numPageViewsList: NumPageViews[];
}

export interface NumPageViews {
  idCbiEntity: number;
  numPageViews: number;
}

export interface GenerateAddressInfoRequest {
  idCountry: number;
  zip: string;
}

export interface GenerateAddressInfoResponse {
  stateInfo: StateInfo | undefined;
  cityInfo: CityInfo | undefined;
}

/** to be deprecated - DO NOT USE */
export interface Entity {
  idCbiEntity: number;
  idCompany: number;
  idInvestor: number;
  name: string;
  url: string;
  idPrimaryCbiEntityType: IdType;
}

export interface GetCompanyAndInvestorMatchesRequest {
  entityNames: string[];
  getInactive: boolean;
  urlOrName?: boolean | undefined;
  nameOnly?: boolean | undefined;
  entityUrls: string[];
  entityTypes: IdType[];
}

export interface GetCompanyAndInvestorMatchesResponse {
  entities: Entity[];
}

export interface EntityPerson {
  idInvPerson: number;
  firstName: string;
  middleName: string;
  lastName: string;
  bio: string;
  bioSource: string;
  linkedin: string;
  twitter: string;
  workExperience: WorkExperience[];
  boardAssociations: BoardAssociation[];
  education: Education[];
  tsUpdated: string;
  email: string;
  /** if multiple sources they will be here (cbi_data.entity_person_source) */
  idSources: number[];
  logoUrl: string;
  location: EntityPersonLocation | undefined;
  tsLastAudited: string;
  tsUserModified: string;
  note: string;
  peopleTags: PeopleTag[];
  idUserUpdated: number;
  stealthStatus: StealthStatus;
}

export interface EntityPersonLocation {
  idCity: number;
  idState: number;
  idCountry: number;
}

export interface WorkExperience {
  idCbiEntity: number;
  entityName: string;
  title: PersonTitle | undefined;
  function: string;
  current: boolean;
  startDate: string;
  endDate: string;
  idWorkExperience: number;
  idCompany: number;
  idInvestor: number;
  entityUrl: string;
  department: Department;
  managementLevel: ManagementLevel;
  rawTitle: string;
  description: string;
  displayDepartment: DisplayDepartment;
  displayManagementLevel: DisplayManagementLevel;
  coresignalExperienceId: string;
  isMappedEntity: boolean;
  isManualPeopleUpdatePermitted: boolean;
}

export interface BoardAssociation {
  idCbiEntity: number;
  entityName: string;
  title: PersonTitle | undefined;
  current: boolean;
  startDate: string;
  endDate: string;
  fundingRounds: FundingRound[];
  idBoardAssociation: number;
  idSource: number;
  idCompany: number;
  idInvestor: number;
}

export interface School {
  idSchool: number;
  school: string;
}

export interface Degree {
  idDegree: number;
  degree: string;
}

export interface FieldOfStudy {
  idFieldOfStudy: number;
  fieldOfStudy: string;
}

export interface Education {
  school: School | undefined;
  degree: Degree | undefined;
  fieldOfStudy: FieldOfStudy | undefined;
  idEntityPersonEducation: number;
  graduationYear: number;
  displayDegree: DisplayDegree;
}

export interface AllDegrees {
  degrees: Degree[];
}

export interface AllFieldsOfStudy {
  fieldsOfStudy: FieldOfStudy[];
}

export interface ListEntityPeopleRequest {
  nameFilter: string;
  idCbiEntityFilter: number[];
  idTitlesFilter: number[];
  currentStatusFilter?: boolean | undefined;
  formerStatusFilter?: boolean | undefined;
  limit: number;
  offset: number;
  view: ListEntityPeopleRequest_ListEntityPeopleView;
  idInvPersonFilter: number[];
  lastUpdateTime: string;
  returnAllWorkExperience: boolean;
  isAdmin: boolean;
  /** if true, we'll skip a count query to generate the total result count and always return 0 */
  skipTotalResults: boolean;
  skipMergingWorkExperiences: boolean;
  /** if true, skip the ORDER BY on work experience and board associations (caller does not care about ordering) */
  skipSort: boolean;
}

export enum ListEntityPeopleRequest_ListEntityPeopleView {
  /** LIST_ENTITY_PEOPLE_VIEW_UNSPECIFIED - Will default to the BASIC view */
  LIST_ENTITY_PEOPLE_VIEW_UNSPECIFIED = "LIST_ENTITY_PEOPLE_VIEW_UNSPECIFIED",
  /** BASIC - All matched person details but only work experience and board memberships that matched the filters */
  BASIC = "BASIC",
  /** FULL - All matched person details and entire work experience and board memberships */
  FULL = "FULL",
  /** ID_INV_PERSON_ONLY - Only returns matching id_investor_person */
  ID_INV_PERSON_ONLY = "ID_INV_PERSON_ONLY",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export interface ListEntityPeopleResponse {
  entityPeople: EntityPerson[];
  totalResults: number;
}

export interface UpdateEntityPersonRequest {
  person: EntityPerson | undefined;
  workExperienceIdsToDelete: number[];
  boardAssociationsIdsToDelete: number[];
  fundingRoundIdsToDelete: number[];
  entityPersonEducationIdsToDelete: number[];
}

export interface UpdateEntityPersonNoteRequest {
  idEntityPerson: number;
  note: string;
}

export interface UpdateEntityPersonNoteResponse {
  success: boolean;
}

export interface DetectDuplicateLinkedinUrlsRequest {
  urls: string[];
}

export interface DetectDuplicateLinkedinUrlsResponse {
  linkedinToIdInvPeople: { [key: string]: DetectDuplicateLinkedinUrlsResponse_IdInvPeople };
}

export interface DetectDuplicateLinkedinUrlsResponse_IdInvPeople {
  idInvPeople: number[];
}

export interface DetectDuplicateLinkedinUrlsResponse_LinkedinToIdInvPeopleEntry {
  key: string;
  value: DetectDuplicateLinkedinUrlsResponse_IdInvPeople | undefined;
}

export interface GetEntityPersonRequest {
  idInvPerson: number;
}

export interface BatchGetEntityPeopleRequest {
  idInvPeople: number[];
  skipBasicInfo: boolean;
  skipCurrentWorkExperience: boolean;
  skipPastWorkExperience: boolean;
  skipBoardAssociations: boolean;
  skipEducation: boolean;
}

export interface BatchGetEntityPeopleResponse {
  people: EntityPerson[];
}

export interface DeleteEntityPeopleRequest {
  idInvPeople: number[];
}

export interface MarkEntityPersonAuditedRequest {
  idInvPerson: number;
}

export interface MarkEntityPersonAuditedResponse {
  tsLastAudited: string;
}

export interface BatchPublishEntityPeopleRequest {
  idInvPeople: number[];
}

export interface SearchSchoolsResponse {
  schools: School[];
}

export interface GetEntitiesRevenuesRequest {
  idCbiEntities: number[];
  allowCurrentAndFutureDates: boolean;
}

export interface GetEntitiesRevenuesResponse {
  entitiesRevenueData: EntityRevenueData[];
}

export interface EntityRevenueData {
  idCbiEntity: number;
  entityRevenues: EntityRevenue[];
  entityKPIs: EntityKPIs | undefined;
}

export interface EntityRevenue {
  revenueDate: string;
  revenueMinAmount: number;
  revenueMaxAmount: number;
  revenueSources: string[];
  revenueSourceType: string;
  revenueTimePeriod: string;
  revenueMultiple?: number | undefined;
  yoyGrowthPercent?: number | undefined;
  isActual: boolean;
}

export interface EntityKPIs {
  /** public companies will only ever return this value */
  latestRevenue?: KPIRevenue | undefined;
  latestRevenueGrowth?: KPIRevenueGrowth | undefined;
  futureRevenue?: KPIRevenue | undefined;
  revenueMultiple?: KPIRevenueMultiple | undefined;
  revenuePerHeadcount?: KPIRevenuePerHeadcount | undefined;
  futureRevenueGrowth?: KPIRevenueGrowth | undefined;
}

export interface KPIRevenue {
  calendarYear: number;
  revenueAmount: number;
}

export interface KPIRevenueGrowth {
  calendarYear: number;
  growthPercent: number;
  /** yoy or cagr */
  growthType: RevenueGrowthType;
  previousCalendarYear: number;
}

export interface KPIRevenueMultiple {
  calendarYear: number;
  multiple: number;
}

export interface KPIRevenuePerHeadcount {
  calendarYear: number;
  revenuePerHeadcount: number;
}

export interface ServiceProvider {
  idCbiEntity: number;
  idServiceProvider: number;
  serviceProviderType: ServiceProviderType | undefined;
  entityName: string;
  entityUrl: string;
  description: string;
  logoUrl: string;
}

export interface ServiceProviderType {
  idServiceProviderType: number;
  serviceProviderType: string;
}

export interface ServiceProviderRelationship {
  idServiceProviderRelationship: number;
  idCbiEntityServiceProvider: number;
  idCbiEntityClient: number;
  entityNameServiceProvider: string;
  entityNameClient: string;
  associatedTransaction: ServiceProviderTransaction | undefined;
  source: string;
  idServiceProvider: number;
  serviceProviderRelationshipServiceTypes: ServiceProviderRelationshipServiceType[];
  serviceProviderType: ServiceProviderType | undefined;
  idCompanyServiceProvider: number;
  idCompanyClient: number;
  idInvestorClient: number;
}

export interface ServiceProviderRelationshipServiceType {
  idServiceProviderRelationshipServiceType: number;
  serviceType: ServiceType | undefined;
}

export interface ServiceType {
  idServiceType: number;
  serviceType: string;
}

export interface ServiceProviderTransaction {
  idCbiEntity: number;
  entityName: string;
  fundingRound: FundingRound | undefined;
  isSell: boolean;
  exitIndicator: boolean;
}

export interface DeleteServiceProviderRequest {
  idServiceProvider: number;
}

export interface DeleteServiceProviderRelationshipRequest {
  idServiceProviderRelationship: number;
}

export interface GetServiceProviderInfoRequest {
  idCbiEntity: number;
  idServiceProvider: number;
}

export interface GetServiceProviderInfoResponse {
  serviceProvider: ServiceProvider | undefined;
  hasClient: boolean;
  /** DEPRECATED, use GetEntityClientRelationships */
  clients: ServiceProviderRelationship[];
  /** DEPRECATED, use GetEntityServiceProviderRelationships */
  serviceProviders: ServiceProviderRelationship[];
}

export interface Filter {
  field: string;
  value: string;
}

export interface GetEntityClientRelationshipsRequest {
  idCbiEntity: number;
  limit: number;
  offset: number;
  groupBy: GroupBy;
  /** accepted filter fields: associatedRounds, clientName, providerType, serviceType */
  filters: Filter[];
  /** accepted sort columns: associatedRounds, clientName, providerType, serviceType, idServiceProviderRelationship, serviceProviderName */
  sortColumn: string;
  sortOrder: SortOrder;
}

export interface GetEntityClientRelationshipsResponse {
  clients: ServiceProviderRelationship[];
  totalCount: number;
}

export interface GetEntityServiceProviderRelationshipsRequest {
  idCbiEntity: number;
  limit: number;
  offset: number;
  groupBy: GroupBy;
  sortColumn: string;
  sortOrder: SortOrder;
}

export interface GetEntityServiceProviderRelationshipsResponse {
  serviceProviders: ServiceProviderRelationship[];
  totalCount: number;
}

export interface ListServiceProviderTypesRequest {
}

export interface ListServiceProviderTypesResponse {
  serviceProviderTypes: ServiceProviderType[];
}

export interface ListServiceTypesRequest {
}

export interface ListServiceTypesResponse {
  serviceTypeMaps: { [key: number]: ListServiceTypesResponse_ServiceTypes };
}

export interface ListServiceTypesResponse_ServiceTypes {
  serviceTypes: ServiceType[];
}

export interface ListServiceTypesResponse_ServiceTypeMapsEntry {
  key: number;
  value: ListServiceTypesResponse_ServiceTypes | undefined;
}

export interface GetOutdatedSlugsRequest {
  companyBatchSize: number;
  investorBatchSize: number;
}

export interface GetOutdatedSlugsResponse {
  slugs: OutdatedSlug[];
}

export interface OutdatedSlug {
  id: number;
  name: string;
  slug: string;
  entity_type: number;
}

export interface UpdateSlugsRequest {
  companySlugs: UpdatedSlug[];
  investorSlugs: UpdatedSlug[];
}

export interface UpdatedSlug {
  id: number;
  slug: string;
  updated: boolean;
  entity_type: number;
}

export interface CreateEntityDraftRequest {
  entityInfo: EntityInfo | undefined;
  entityDraftInfo:
    | EntityDraftInfo
    | undefined;
  /** tmp field only */
  useDraft: boolean;
  /** when createEntityShellDraft is true, we only require the primary url */
  createEntityShellDraft: boolean;
}

export interface CreateEntityDraftResponse {
  idEntityDraft: string;
}

export interface BatchCreateEntityDraftsRequest {
  entityDraftsInfo: EntityDraftInfo[];
  createEntityShellDraft: boolean;
}

export interface BatchCreateEntityDraftsResponse {
  idEntityDrafts: string[];
}

export interface UpdateEntityDraftRequest {
  /**
   * The Mask is applied to EntityInfo, so paths should be relative to EntityInfo.
   * example of updating description and primary url:
   * paths: ["description", "urlInfo.primaryUrl"]
   *
   * IMPORTANT: For repeated fields (e.g. urlInfo.additionalUrls, idParentEntities),
   * the mask replaces the entire list. You MUST fetch the existing records first and
   * include them in the request, otherwise they will be removed.
   *
   * NOTE: For tagGroups, use cbi-tag-service directly instead of this endpoint.
   */
  entityInfoMask: string[] | undefined;
  entityDraftInfo: EntityDraftInfo | undefined;
  skipValidation: boolean;
}

export interface UpdateEntityDraftResponse {
  successStatus: SuccessStatus | undefined;
  idEntityDraft: string;
  version: number;
  isDraftValid: boolean;
}

export interface ListEntityDraftsRequest {
  idEntityDrafts: string[];
  idCbiEntities: number[];
  generalFilters: GeneralFilter[];
  entityDraftFilters: EntityFilter[];
  limit: number;
  offset: number;
  idCbiEntitiesToExclude: number[];
  idEntityDraftsToExclude: string[];
}

export interface EntityDraftInfo {
  entityInfo: EntityInfo | undefined;
  entityDraftMetadata: EntityDraftMetadata | undefined;
}

export interface EntityDraftMetadata {
  version: number;
  lastUpdated: string;
  fieldCount: number;
  lastModifiedUser: User | undefined;
  sourceData: SourceData[];
  draftStatus: DraftStatus;
  creationDate: string;
  creationUserId: number;
}

export interface ListEntityDraftsResponse {
  entityDraftInfo: EntityDraftInfo[];
}

export interface DiscardEntityDraftsRequest {
  entityDrafts: EntityDraftInfo[];
  idCbiEntities: number[];
}

export interface DiscardEntityDraftsResponse {
  successStatus: SuccessStatus | undefined;
}

export interface PublishEntityDraftRequest {
  idEntityDraft: string;
  entityDraftInfo: EntityDraftInfo | undefined;
  idCbiEntity: number;
  isCorrect?:
    | boolean
    | undefined;
  /**
   * The Mask is applied to EntityInfo, so paths should be relative to EntityInfo.
   * example of updating description and primary url:
   * paths: ["description", "urlInfo.primaryUrl"]
   *
   * IMPORTANT: For repeated fields (e.g. urlInfo.additionalUrls, idParentEntities),
   * the mask replaces the entire list. You MUST fetch the existing records first and
   * include them in the request, otherwise they will be removed.
   *
   * NOTE: For tagGroups, use cbi-tag-service directly instead of this endpoint.
   */
  entityInfoMask: string[] | undefined;
}

export interface PublishEntityDraftResponse {
  successStatus: SuccessStatus | undefined;
  idCbiEntity: number;
}

export interface HasPendingEntityDraftsRequest {
  idCbiEntity?: number | undefined;
  idEntityDraft?: string | undefined;
}

export interface HasPendingEntityDraftsResponse {
  hasPendingDrafts: boolean;
}

export interface CreateEntityNoteRequest {
  idCbiEntity?: number | undefined;
  idEntityDraft?: string | undefined;
  note: string;
}

export interface CreateEntityNoteResponse {
  successStatus: SuccessStatus | undefined;
}

export interface User {
  idUser: number;
  firstName: string;
  lastName: string;
}

export interface EntityNote {
  idEntityNote: number;
  note: string;
  user: User | undefined;
  tsInsert: string;
}

export interface ListEntityNotesRequest {
  idCbiEntity?: number | undefined;
  idEntityDraft?: string | undefined;
}

export interface ListEntityNotesResponse {
  entityNotes: EntityNote[];
}

export interface DeleteEntityNotesRequest {
  idCbiEntities: number[];
  idEntityDrafts: string[];
  idEntityNotes: number[];
}

export interface DeleteEntityNotesResponse {
  successStatus: SuccessStatus | undefined;
}

export interface GetDraftCountsRequest {
  publishedDraftCountStartDate: string;
  sourceTypes: number[];
}

export interface GetDraftCountsResponse {
  pendingDraftCount: number;
  publishedDraftCount: number;
  enrichmentDraftCount: number;
  qaDraftCount: number;
}

export interface GetDraftersRequest {
  startDate: string;
  endDate: string;
  pendingRecordsOnly?: boolean | undefined;
  publishedRecordsOnly?: boolean | undefined;
  qaAndPublishedRecordsOnly?: boolean | undefined;
}

export interface GetDraftersResponse {
  users: User[];
  idUserToAdminRoles: { [key: number]: UserAdminRoles };
}

export interface GetDraftersResponse_IdUserToAdminRolesEntry {
  key: number;
  value: UserAdminRoles | undefined;
}

export interface UserAdminRoles {
  idUser: number;
  adminRoles: AdminRole[];
}

export interface AdminRole {
  idAdminRole: number;
  adminRole: string;
}

export interface GeneralFilter {
  drafterFilter?: DrafterFilter | undefined;
  dateFilter?: DateFilter | undefined;
  statusFilter?: StatusFilter | undefined;
  sourceTypeFilter?: SourceTypeFilter | undefined;
}

export interface EntityFilter {
}

export interface StatusFilter {
  draftStatuses: DraftStatus[];
}

export interface SourceTypeFilter {
  sourceTypes: SourceType[];
}

export interface DrafterFilter {
  idDrafters: number[];
}

export interface DateFilter {
  startDate: string;
  endDate: string;
}

export interface GetEntityInfoRequest {
  idEntityDraft: string;
  idCbiEntity: number;
}

export interface GetEntityInfoResponse {
  entityInfo: EntityInfo | undefined;
  entityDraftInfo: EntityDraftInfo | undefined;
  lastPublishedDate: string;
  userCanMarkDraftCorrect: boolean;
}

export interface EntityDraftSourceType {
  idEntityDraftSourceType: number;
  entityDraftSourceType: string;
}

export interface AllEntityDraftSourceTypes {
  entityDraftSourceTypes: EntityDraftSourceType[];
}

export interface EntityDraftStatusType {
  idEntityDraftStatusType: number;
  entityDraftStatusType: string;
}

export interface AllEntityDraftStatusTypes {
  entityDraftStatusTypes: EntityDraftStatusType[];
}

export interface GetDeletedCompetitorsRequest {
  idCbiEntities: number[];
}

export interface GenerateAuditReportRequest {
  idUsers: number[];
  startDate: string;
  endDate: string;
  fieldsReport: boolean;
  summaryReport: boolean;
}

export interface GenerateAuditReportResponse {
  userAuditInfo: UserAuditInfo[];
}

export interface UserAuditInfo {
  idUser: number;
  fullUserName: string;
  email: string;
  summaryAuditInfo: SummaryAuditInfo | undefined;
  fieldsAuditInfo: FieldsAuditInfo[];
}

export interface FieldsAuditInfo {
  draftName: string;
  publishedName: string;
  draftURL: string;
  publishedURL: string;
  draftStatus: string;
  publishedStatus: string;
  draftDescription: string;
  publishedDescription: string;
  draftPrimaryEntityType: string;
  publishedPrimaryEntityType: string;
  draftCountry: string;
  publishedCountry: string;
  draftPostal: string;
  publishedPostal: string;
  draftState: string;
  publishedState: string;
  draftCity: string;
  publishedCity: string;
  draftStreet1: string;
  publishedStreet1: string;
  draftStreet2: string;
  publishedStreet2: string;
  draftPhone: string;
  publishedPhone: string;
  draftFoundedYear: string;
  publishedFoundedYear: string;
  draftSector: string;
  publishedSector: string;
  draftIndustry: string;
  publishedIndustry: string;
  draftSubIndustry: string;
  publishedSubIndustry: string;
  draftAliases: string;
  publishedAliases: string;
  draftAltURL: string;
  publishedAltURL: string;
  draftInvestorCategory: string;
  publishedInvestorCategory: string;
  extraDraftAddresses: string[];
  extraPublishedAddresses: string[];
  lastUpdated: string;
  idCbiEntity: number;
  draftCIKS: string;
  publishedCIKS: string;
  draftHqFlag: string;
  publishedHqFlag: string;
  url: string;
}

export interface SummaryAuditInfo {
  correctDraftsCount: number;
  incorrectDraftsCount: number;
  percentMarkedCorrect: number;
  totalDraftsSubmitted: number;
  totalDraftsReviewed: number;
}

export interface ListTagGroupsRequest {
  /** not required, by default will return all tag groups */
  idTagGroup: number;
  excludeTag: boolean;
}

export interface ListTagGroupsResponse {
  tagGroups: TagGroup[];
}

export interface TagGroup {
  idTagGroup: number;
  tagGroup: string;
  tags: Tag[];
}

export interface Tag {
  idTag: number;
  tag: string;
  description: string;
  /**
   * Source attributed to this tag when a NEW tag-entity assignment is created
   * for it. Existing assignments are not updated. Leave as SOURCE_UNSPECIFIED
   * to store NULL (legacy behavior).
   */
  tagSource: TagSource;
}

export interface GetUniversityAlumniIdsRequest {
  idCbiEntity: number;
}

export interface GetUniversityAlumniIdsResponse {
  idPeople: number[];
}

export interface PeopleTag {
  idPersonTag: number;
  tagName: string;
  tagValue: number;
  idCbiEntities: number[];
}

export interface PublishEntityPersonTagsRequest {
  idEntityPerson: number;
  peopleTags: PeopleTag[];
}

export interface PublishEntityPersonTagsResponse {
}
